import { useFeature } from '@mafc/appshell';
import { LOYALTY_POINT_TYPE } from '../loyaltyPoints.constants';
import { GROWTHBOOK_FLAGS } from 'pages/NewCart/constants/growthbook.constants';

const useLoyaltyPointType = () => {
  const { value: loyaltyPointType } = useFeature(GROWTHBOOK_FLAGS.LOYALTY_POINT_TYPE);

  return {
    isShare: LOYALTY_POINT_TYPE.SHARE === loyaltyPointType,
    isMyClub: LOYALTY_POINT_TYPE.MY_CLUB === loyaltyPointType,
    type: loyaltyPointType,
  };
};

export default useLoyaltyPointType;
